import React from 'react';
import {
  TableRow,
  TableCell,
} from '../../../../../../components/customTableComponents';
import { CardsContainer, HistoryAndMap } from '../../../../../../components/requestComponents';

const ExpandedContent = ({ request, canChange = true }) => {
  return (
    <>
      <TableRow>
        <TableCell padding="empty" transparent />
        <TableCell
          rowSpan={2}
          colSpan={6}
          position="bottomRight"
          verticalAlign="top"
        >
          <CardsContainer request={request} canChange={canChange} />
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell padding="empty" transparent />
        <TableCell verticalAlign="bottom" position="bottomLeft">
          <HistoryAndMap request={request} />
        </TableCell>
      </TableRow>
    </>
  );
};

export default ExpandedContent;
